<template>
  <v-card class="rating-block" max-width="500px" flat>
    <div class="text-center mb-5">
      <v-rating v-model="score" background-color="primary" color="primary" large></v-rating>
    </div>

    <v-textarea
      v-if="activeComments"
      outlined
      :label="$t('rating.labelArea')"
      v-model="comment"
      maxlength="255"
      counter="255"
    ></v-textarea>

    <div class="text-center">
      <v-btn color="primary" @click="eventSendRating" :loading="loading" :disabled="score === 0">{{
        $t('common.send')
      }}</v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'Rating',

  props: {
    activeComments: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      score: 0,
      comment: '',
      loading: false
    }
  },

  methods: {
    reset() {
      this.score = 0
      this.comment = ''
    },
    async eventSendRating() {
      const data = {
        score: this.score,
        comment: this.comment
      }

      this.loading = true

      const res = await this.$emit('event-send-rating', {
        data,
        done: (res) => {
          if (res) {
            this.loading = false
            this.reset()
          } else {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.rating-block
  margin: 0 auto
</style>
